import { render } from "./ProfileContent.vue?vue&type=template&id=117bc1c4"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__